import { createGlobalStyle, css } from 'styled-components';
import breakpoints from '../../../utilities/breakpoints';

const bannerThemeCss = (color: string, backgroundColor: string) => css`
    background-color: ${backgroundColor};
    border-left: 0.25rem solid ${color};

    .ant-notification-notice-icon svg {
        color: ${color};
    }

    .ant-notification-notice-close-x:hover {
        svg {
            color: ${color};
        }
    }
`;

const NotificationGlobalStyle = createGlobalStyle`
    body {
        .ant-notification-notice.porsche-theme-toast,
        .ant-notification-notice.porsche-theme-banner {
            padding: 1rem;
            border-radius: 0;
            box-shadow: rgba(0, 0, 0, 0.05) 0px 0.125rem 0.25rem 0px, rgba(0, 0, 0, 0.2) 0px 0.9375rem 1.25rem 0px;

            .ant-notification-notice-with-icon {
                .ant-notification-notice-icon {
                    margin-left: 0;
                }

                .ant-notification-notice-message,
                .ant-notification-notice-description {
                    margin-left: 32px;
                    color: #000000;
                }

                .ant-notification-notice-message {
                    margin-bottom: 0;
                }
            }

            .ant-notification-notice-close {
                right: 16px;
            }
        }

        .ant-notification-notice.porsche-theme-toast {
            width: auto;
            padding-right: 30px;
            @media screen and (max-width: ${breakpoints.md}) {
                margin-bottom: 70px;
                margin-left: 0;
            }
            &.porsche-theme-toast-loading { 
                ${bannerThemeCss('#0061bd', '#e5eff8')}    
            }
            &.porsche-theme-toast-success {
                ${bannerThemeCss('#00bd52', '#e6fcf0')}
            }
        }

        .ant-notification-notice.porsche-theme-banner {
            width: calc(100vw - 120px);

            @media screen and (max-width: ${breakpoints.md}) {
                width: calc(100vw - 48px);
                max-width: calc(100vw - 48px);
            }

            .ant-notification-notice-message {
                font-weight: 600;
            }

            .ant-notification-notice-description {
                font-size: 16px;

                &:not(:empty) {
                    margin-top: 0.25rem;
                }
            }

            &.porsche-theme-banner-error {
                ${bannerThemeCss('#e00000', '#fae6e6')}
            }

            &.porsche-theme-banner-warning {
                ${bannerThemeCss('#ff9b00', '#fff5e5')}
            }

            &.porsche-theme-banner-success {
                ${bannerThemeCss('#00bd52', '#e6fcf0')}
            }
            
            &.porsche-theme-banner-info {
                ${bannerThemeCss('#0061bd', '#e5eff8')}
            }
        }
    }
`;

export default NotificationGlobalStyle;
